export default __webpack_public_path__ + "259ce97cf208cea9da1c6fa99ed96ffd.svg";